import { render, staticRenderFns } from "./uploadModal.vue?vue&type=template&id=6065099f&"
import script from "./uploadModal.vue?vue&type=script&lang=js&"
export * from "./uploadModal.vue?vue&type=script&lang=js&"
import style0 from "./uploadModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports